import React, { useEffect, useState } from 'react'

import { Col, Row, Skeleton } from 'antd'

import getReviewReport, { ReviewReport } from 'core/application/docReviewDashboard/home/reviewReport'

import { queryRequest } from 'common/RequestUtils'

import InfoComponent from './InfoComponent'

export const HOME_PATH = 'home'

const Home: React.FC = () => {
  const [reviewReport, setReviewReport] = useState<ReviewReport | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const getReportInfo = async () => {
    const result = await queryRequest(() => getReviewReport())
    setReviewReport(result)
    setLoading(false)
  }

  useEffect(() => {
    getReportInfo()
  }, [])

  return (
    <div data-testid={'doc-review-dashboard'}>
      <Skeleton loading={loading} active paragraph={{ rows: 4, className: 'p-24' }} title={{ className: 'ml-24' }}>
        {reviewReport && (
          <Row>
            <Col span={12} className="card_margin">
              <InfoComponent
                title="Pending"
                iconName="clock"
                iconClassName="color-yellow-7"
                value={reviewReport.totalPending}
              />
            </Col>
            <Col span={12} className="card_margin">
              <InfoComponent
                title="Action required"
                iconName="exclamation-circle"
                iconClassName="color-red-6"
                value={reviewReport.totalActionRequired}
              />
            </Col>
            <Col span={12} className="card_margin">
              <InfoComponent
                title="FTA YTD"
                iconName="check-circle"
                iconClassName="color-green-6"
                value={reviewReport.totalFtaYtd}
              />
            </Col>
            <Col span={12} className="card_margin">
              <InfoComponent
                title="FTA Last 2 Mo"
                iconName="check-circle"
                iconClassName="color-green-6"
                value={reviewReport.totalFtaLast2Months}
              />
            </Col>
          </Row>
        )}
      </Skeleton>
    </div>
  )
}

export default Home
